import React from 'react'
import Button from 'components/Button'
import { FormattedMessage } from 'react-intl'
import ArrowLeftLine from 'assets/icons/arrow-left-line'
import {NewSiteFooterButtonWrapper} from './style'

const AddStateEvaluationModal = ({ children, onClose, padding = '32px' }) => {

  return (
    <div
      style={{
        width: '100%',
        maxWidth: '1200px',
        background: '#fff',
        borderRadius: '8px',
        padding: '0',
        height: "80vh",
        overflowY: 'auto',
        border: '1px solid rgba(32, 32, 32, 0.1)',
        position: 'sticky',
       
      }}
    >
     <div
  style={{
    display: 'flex',          
    justifyContent: 'flex-end', 
    alignItems: 'center',     
    padding: '10px 16px',      
    background: '#fff',
    borderBottom:'1px solid rgba(32, 32, 32, 0.1)'
  }}
>
  
  <NewSiteFooterButtonWrapper onClick={onClose}>
    <Button height="40px" withIcon={true}>
      <ArrowLeftLine />
      <FormattedMessage id="backToSelection" />
    </Button>
  </NewSiteFooterButtonWrapper>
</div>

      <div style={{ padding }}>{children}</div>
    </div>
  )
}

export default AddStateEvaluationModal
